import axios from "../../config/axiosConfig";
import {
  CREATE_SALES_BILL, DELETE_SALES_BILL,
  GET_SALES_BILLS,
  GET_SALES_BILLS_PAGE,
  SALES_BILL_REQUEST,
  SALES_BILL_REQUEST_SUCCESS,
  SALES_BILL_REQUEST_FAILURE,
  GET_AVAILABLE_PURCHASE_BILLS,
  UPDATE_SALES_BILL,
  CANCEL_EWAY_BILL
} from "../types/sales-bill-types";

export const getSalesBillsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Grade_Id,Lot_Id,Broker_Id'
      };
      return axios.get("/sales-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_BILLS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesBills = (commonMaster, include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id };
      if (commonMaster !== undefined) {
          params = {
            ...params,
            companyId: commonMaster ? undefined : auth.company?.id
          };
      }
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/sales-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_BILLS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesBillsByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/sales-bill/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesAccountTurnover = (accountId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        accountId: accountId
      };
      
      const response = await axios.get("/sales-bill/get-account-turnover", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesBillById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
    
      return axios.get(`/sales-bill/get/${id}`).then((response) => {
        dispatch({ type: SALES_BILL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message }); 
        throw error; 
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createSalesBill = (salesbill) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SALES_BILL_REQUEST });
      const newSalesBill = {
        ...salesbill
      };
      return axios.post("/sales-bill/add", newSalesBill,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SALES_BILL, payload: response.data });
        } else {
          dispatch({
            type: SALES_BILL_REQUEST_FAILURE,
            error: "Sales bill create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSalesBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      return axios.put("/sales-bill/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: SALES_BILL_REQUEST_FAILURE,
            error: "Sales bill update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSalesBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      return axios.delete(`/sales-bill/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SALES_BILL, id: id });
          const include = ['id', 'Invoice_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Grade_Id', 'Lot_Id', 'Net_Total'].join(',');
          const searchCols = ['Invoice_No'].join(',');
          const { inventory: { salesBill: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getSalesBillsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEwaySalesBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      return axios.post(`/sales-bill/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const extendValidityEwaySalesBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      return axios.post(`/sales-bill/extend-validity-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingSalesOrders = (industryTypeId, accountId, bookId, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        industryTypeId,
        accountId,
        bookId,
        id
      };
      
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/sales-bill/getRemainingOrders`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const printSalesBills = (ewaybillNumber, type) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: SALES_BILL_REQUEST });
      console.log("Printing E-Way Bill with number:", ewaybillNumber);
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber, type };
      console.log("Params for printing E-Way Bill:", params);
      return axios.get("/sales-bill/print-eway-bill", { params, responseType: "blob", }).then((response) => {
        return response.data;
        // if (response.data) {
        //   dispatch({ type: GET_SALES_BILLS, payload: response.data });
        // }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEwaySalesBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      // let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      // console.log('params', params);
      // let data = {};
      
      return axios.get(`/sales-bill/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEInvoiceSalesBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      
      return axios.get(`/sales-bill/generate-e-invoice/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEInvoiceSalesBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      return axios.post(`/sales-bill/cancel-e-invoice/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_SALES_BILL,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletedEInvoiceSalesBill = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sales-bill/delete-e-invoice-bills", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAvailablePurchaseBillsForSalesBill = (salesBillId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        salesBillId,
      };
      return axios.get(`/sales-bill/get-available-purchase-bills`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_AVAILABLE_PURCHASE_BILLS, payload: response.data });
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const sendMailSaleBill = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('salesBillId', mailData.salesBillId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `sales_bill_${mailData.salesBillId}.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-bill/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_BILL_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_BILL_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_BILL_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappSaleBill = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_BILL_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('salesBillId', whatsappData.salesBillId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `sales_bill.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-bill/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_BILL_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_BILL_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_BILL_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const validatePartyInSalesBill = (partyId, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id };
      }
      const response = await axios.get("/sales-bill/validate-party", { params: { ...params, partyId, bookId } });
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesBillByInvoiceNo = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo
      };
      return axios.get(`/sales-bill/get-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};


export const getSalesBillsListByInvoiceNo = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo
      };
      return axios.get(`/sales-bill/get-all-bills-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSalesBillMissingNos = (payload) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        ...payload
      };
      return axios.get(`/sales-bill/get-missing-nos`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDeliveryChallanByChallanNoForSalesBill = (bookId, challanNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        bookId, challanNo
      };
      const response = await axios.get("/sales-bill/get-challan-by-challan-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPincodeToPincodeDistanceGetSaleBill = (saleBillId, fromPincode) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        billId: saleBillId,
        fromPincode
      };
      const response = await axios.get("/sales-bill/get-pincode-to-pincode-distance", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPartyItemWiseRateInSalesBill = (accountId, itemId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        accountId, itemId
      };
      const response = await axios.get("/sales-bill/get-party-item-wise-rate", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const updateBrokerInBulkSalesBills = (brokerId, billIds) => {
  return async (dispatch, getState) => {
    try {
      return axios.post("/sales-bill/update-broker-in-bulk-sales-bills", { brokerId, billIds }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};